import React from "react";

function index(props) {
  return (
    <span id={props.id} onClick={props.changeView}>
      {props.visible ? (
        <svg
          className="ds-svg-icon"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="#8f9bb3"
        >
          <path
            id="eye-off-2_svg__a"
            d="M17.81 13.395a8.947 8.947 0 003.182-5.771 1 1 0 00-1.984-.249C18.57 10.867 15.556 13.5 12 13.5s-6.569-2.633-7.008-6.125a1 1 0 10-1.984.249 8.947 8.947 0 003.183 5.771L3.88 15.707a1.003 1.003 0 000 1.414 1.003 1.003 0 001.414 0l2.603-2.603c.954.482 2.001.8 3.104.921V19c0 .55.45 1 1 1s1-.45 1-1v-3.561a9.062 9.062 0 003.103-.921l2.604 2.603a1.003 1.003 0 001.414 0 1.003 1.003 0 000-1.414l-2.312-2.312z"
          ></path>
        </svg>
      ) : (
        <svg
          className="ds-svg-icon"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="#8f9bb3"
        >
          <path
            id="eye_svg__a"
            d="M12 13.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m0-5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m.22 8.498c-4.306.1-7.115-3.583-8.047-5.002 1.026-1.605 3.61-4.891 7.608-4.993 4.289-.11 7.114 3.583 8.046 5.002-1.025 1.605-3.61 4.89-7.607 4.993m9.648-5.495c-.638-1.112-4.162-6.686-10.138-6.5-5.528.14-8.743 5.01-9.597 6.5a.999.999 0 000 .995C2.762 13.595 6.162 19 12.025 19l.246-.003c5.527-.141 8.743-5.01 9.597-6.5a1.004 1.004 0 000-.994"
          ></path>
        </svg>
      )}
    </span>
  );
}

export default index;
